module.exports = __webpack_public_path__ + "static/media/divulgadorSmall.f724a1d6.svg";